// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dXgG","right":"styles_right__2IkFR"};